import { toast } from "react-toastify"
import { SubformProps } from "."
import LoanSummary from "../../components/loan-summary"
import { useAppState, useConsumerCalcs } from "../../hooks"
import { ConsumerResourceLinks } from "./consumer-resource-links"
import { lappToFormData } from "./util"
import api from "../../api-client"
import { PreNTPUpdate } from "@oneethos/shared"
import { useState } from "react"
import { Spinner } from "@fluentui/react"

export const AwaitingContractLanguage = () => {
  const { tenant } = useAppState()

  return <>
    <p>
      To protect your credit, we require your installer to upload a signed
      installation contract before you can submit your loan application. This ensures
      that your credit is not negatively impacted while we're waiting on your installer
      to proceed with your project.
    </p>
    <p>
      Once your installer has uploaded the contract, you will be prompted to review and submit your
      loan application. Expect to receive an email from {tenant.config.bankEmail} that will
      include instructions on how to proceed.
    </p>
  </>
}

export const AwaitingContract = ({
  formData,
  update,
  onError,
  save
}: Partial<SubformProps>) => {
  const { tenant } = useAppState()
  const { loanTermInYears, rate, amortization } = useConsumerCalcs(formData)
  const { incentive } = formData
  const [saving, setSaving] = useState(false)
  const [updatesRequested, setUpdatesRequested] = useState(false)

  return <div>
    <h3>Awaiting Contract</h3>
    <p>
      Great news - you've provided all the information needed to proceed with your
      loan application.
    </p>
    <AwaitingContractLanguage />
    <p>
      You have selected a {loanTermInYears}-year loan ({formData.loanDurationMonths} months)
      at a {incentive ? `${incentive.nonIncentiveRate}% before incentives**` : `${rate}%`} interest
      rate. Here's a quick summary of your provisional loan details:
    </p>
    <LoanSummary
      formData={formData}
      incentive={formData.incentive}
      showApr={formData.projectType === 'residential' && !formData.incentive}
      amortization={amortization}
    />
    <ConsumerResourceLinks formData={formData} update={update} />
    {/* <div className="mb-3">You can bookmark this page, leave
      the window open, or access the page at any time from the link you received in your initial
      referral email from {tenant.config.bankEmail}.</div> */}
    {saving ? <><Spinner /> Saving...</> : <>
      {updatesRequested ? <div className="alert alert-info">
        Your installer has been notified that your project is pending contract. You will be notified
        once the contract has been uploaded. Once the contract has been uploaded, you will be
        prompted to review the details and submit your loan application.
      </div> : <div className="buttons">
        <button
          type="button"
          className="btn btn-primary"
          onClick={async () => {
            setSaving(true)
            save({
              advance: false,
              addlPatchQuery: { notify: PreNTPUpdate.AwaitingContract }
            }).then(() => setUpdatesRequested(true))
              .catch(onError)
              .finally(() => {
                setSaving(false)
              })
          }}
        >Save & Notify Installer</button>
      </div>}
    </>}
  </div >
}
